/** @public */
export enum LogLevel {
    VERBOSE = 'verbose',
    DEBUG = 'debug',
    INFO = 'info',
    WARN = 'warn',
    ERROR = 'error',
    CRITICAL = 'critical',
    NONE = 'none',
}
